/* Gift card recipient — toggle in the product form opens a popup that collects
   the native Shopify gift card recipient line item properties. */
(function () {
  var EMAIL_RE = /^[^@\s]+@[^@\s.]+\.[^@\s]+$/;
  var BODY_CLASS = 'open-gift-recipient';
  var instances = [];

  function t(key, fallback) {
    var strings = window.giftCardRecipientStrings || {};
    return strings[key] || fallback;
  }

  function formatDate(value) {
    var parts = value.split('-');
    if (parts.length !== 3) return value;
    var date = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
    if (isNaN(date.getTime())) return value;
    try {
      return date.toLocaleDateString(document.documentElement.lang || undefined, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });
    } catch (e) {
      return value;
    }
  }

  function GiftCardRecipient(root) {
    this.root = root;
    this.form = document.getElementById(root.dataset.formId) || root.closest('form');
    this.checkbox = root.querySelector('[data-gcr-checkbox]');
    this.popup = root.querySelector('[data-gcr-popup]');
    this.summary = root.querySelector('[data-gcr-summary]');
    this.control = root.querySelector('[data-gcr-control]');
    this.offset = root.querySelector('[data-gcr-offset]');
    this.counter = root.querySelector('[data-gcr-counter]');
    this.liveRegion = root.querySelector('[data-gcr-live-region]');
    this.inputs = {};
    root.querySelectorAll('[data-gcr-input]').forEach(
      function (input) {
        this.inputs[input.dataset.gcrInput] = input;
      }.bind(this)
    );

    if (!this.checkbox || !this.popup) return;
    this.ready = true;

    // The popup is fixed positioned, so it has to sit outside any transformed
    // ancestor. Its inputs stay tied to the product form via their `form`
    // attribute, the way the variant radios do.
    document.body.appendChild(this.popup);

    // With JS available the checkbox drives the control flag, so the no-JS
    // "if_present" fallback has to step aside.
    this.checkbox.disabled = false;
    if (this.control) this.control.disabled = true;
    if (this.offset) this.offset.value = new Date().getTimezoneOffset().toString();

    this.checkbox.addEventListener('change', this.onToggle.bind(this));
    if (this.inputs.message) this.inputs.message.addEventListener('input', this.updateCounter.bind(this));
    if (this.inputs.send_on) {
      var sendOnInput = this.inputs.send_on;
      sendOnInput.addEventListener('input', this.updateDateState.bind(this));
      sendOnInput.addEventListener('change', this.updateDateState.bind(this));
      // The native calendar button is hidden, so the whole field opens the picker.
      sendOnInput.addEventListener('click', function () {
        if (typeof sendOnInput.showPicker !== 'function') return;
        try {
          sendOnInput.showPicker();
        } catch (e) {
          /* Not allowed in this context — the native focus behaviour still applies. */
        }
      });
    }
    Object.keys(this.inputs).forEach(
      function (key) {
        this.inputs[key].addEventListener('input', this.clearError.bind(this, key));
        this.inputs[key].addEventListener('change', this.clearError.bind(this, key));
      }.bind(this)
    );

    this.popup.querySelectorAll('[data-gcr-close]').forEach(
      function (el) {
        el.addEventListener('click', this.onCloseRequest.bind(this));
      }.bind(this)
    );
    var save = this.popup.querySelector('[data-gcr-save]');
    if (save) save.addEventListener('click', this.onSave.bind(this));
    var edit = this.root.querySelector('[data-gcr-edit]');
    if (edit) edit.addEventListener('click', this.open.bind(this));

    document.addEventListener('keydown', this.onKeydown.bind(this));

    if (this.form) {
      // Runs ahead of the theme's own add-to-cart handler, which is bound on
      // the button itself and posts the form data straight to /cart/add.js.
      this.form.addEventListener('click', this.onFormClick.bind(this), true);
      this.form.addEventListener('submit', this.onFormSubmit.bind(this), true);
    }

    this.setEnabled(false);
    this.updateSummary();
    this.updateCounter();
    this.updateDateState();
  }

  GiftCardRecipient.prototype.isOpen = function () {
    return Boolean(this.ready && this.checkbox.checked);
  };

  GiftCardRecipient.prototype.isPopupOpen = function () {
    return Boolean(this.ready && this.popup.classList.contains('is-open'));
  };

  GiftCardRecipient.prototype.setEnabled = function (enabled) {
    Object.keys(this.inputs).forEach(
      function (key) {
        this.inputs[key].disabled = !enabled;
      }.bind(this)
    );
    if (this.offset) this.offset.disabled = !enabled;
  };

  GiftCardRecipient.prototype.clearInputs = function () {
    Object.keys(this.inputs).forEach(
      function (key) {
        this.inputs[key].value = '';
      }.bind(this)
    );
  };

  GiftCardRecipient.prototype.open = function (event) {
    if (event) event.preventDefault();
    if (!this.ready) return;
    this.checkbox.checked = true;
    this.setEnabled(true);
    this.popup.classList.add('is-open');
    document.body.classList.add(BODY_CLASS);
    this.announce(t('expanded', 'Recipient details are shown.'));
    var first = this.inputs.email;
    if (first) {
      window.setTimeout(function () {
        first.focus();
      }, 100);
    }
  };

  GiftCardRecipient.prototype.close = function () {
    this.popup.classList.remove('is-open');
    document.body.classList.remove(BODY_CLASS);
  };

  GiftCardRecipient.prototype.announce = function (message) {
    if (this.liveRegion) this.liveRegion.textContent = message;
  };

  GiftCardRecipient.prototype.onToggle = function () {
    if (this.checkbox.checked) {
      this.open();
    } else {
      this.clearAllErrors();
      this.clearInputs();
      this.setEnabled(false);
      this.updateCounter();
      this.updateDateState();
      this.updateSummary();
      this.close();
      this.announce(t('collapsed', 'Recipient details are hidden.'));
    }
  };

  /* Closing without usable details is treated as "never mind": the toggle goes
     back off rather than leaving a half filled recipient behind. */
  GiftCardRecipient.prototype.onCloseRequest = function (event) {
    if (event) event.preventDefault();
    if (!this.isPopupOpen()) return;
    if (this.hasRequiredValues() && this.validate(false)) {
      this.close();
      this.updateSummary();
      return;
    }
    this.checkbox.checked = false;
    this.onToggle();
  };

  GiftCardRecipient.prototype.onSave = function (event) {
    if (event) event.preventDefault();
    if (!this.validate()) return;
    this.close();
    this.updateSummary();
    this.checkbox.focus();
  };

  GiftCardRecipient.prototype.onKeydown = function (event) {
    if (event.key !== 'Escape' || !this.isPopupOpen()) return;
    this.onCloseRequest();
  };

  GiftCardRecipient.prototype.hasRequiredValues = function () {
    var email = this.inputs.email ? this.inputs.email.value.trim() : '';
    var name = this.inputs.name ? this.inputs.name.value.trim() : '';
    return Boolean(email || name);
  };

  GiftCardRecipient.prototype.updateSummary = function () {
    if (!this.summary) return;
    var show = this.isOpen() && this.hasRequiredValues();
    this.summary.hidden = !show;
    if (!show) return;

    var set = function (key, value) {
      var el = this.summary.querySelector('[data-gcr-summary="' + key + '"]');
      if (el) el.textContent = value || '';
    }.bind(this);

    set('name', this.inputs.name ? this.inputs.name.value.trim() : '');
    set('email', this.inputs.email ? this.inputs.email.value.trim() : '');

    var sendOn = this.inputs.send_on ? this.inputs.send_on.value : '';
    set(
      'send_on',
      sendOn
        ? t('sendingOn', 'Sending on @date').replace('@date', formatDate(sendOn))
        : t('sendingNow', 'Sending right after purchase')
    );
  };

  /* Date inputs have no ::placeholder, so the empty "dd/mm/yyyy" hint is dimmed
     through a class instead. */
  GiftCardRecipient.prototype.updateDateState = function () {
    if (!this.inputs.send_on) return;
    this.inputs.send_on.classList.toggle('has-value', Boolean(this.inputs.send_on.value));
  };

  GiftCardRecipient.prototype.updateCounter = function () {
    if (!this.counter || !this.inputs.message) return;
    var max = parseInt(this.counter.dataset.max, 10) || 200;
    var used = this.inputs.message.value.length;
    var template = used > 0 ? t('charactersUsed', '@used/@max') : t('maxCharacters', 'Max. @max characters');
    this.counter.textContent = template.replace(/@max/g, max).replace(/@used/g, used);
    this.counter.classList.toggle('is-limit', used >= max);
  };

  GiftCardRecipient.prototype.setError = function (key, message) {
    var field = this.popup.querySelector('[data-gcr-field="' + key + '"]');
    var target = this.popup.querySelector('[data-gcr-error="' + key + '"]');
    if (target) target.textContent = message || '';
    if (field) field.classList.toggle('has-error', Boolean(message));
    if (this.inputs[key]) this.inputs[key].setAttribute('aria-invalid', message ? 'true' : 'false');
  };

  GiftCardRecipient.prototype.clearError = function (key) {
    this.setError(key, '');
  };

  GiftCardRecipient.prototype.clearAllErrors = function () {
    Object.keys(this.inputs).forEach(this.clearError.bind(this));
  };

  GiftCardRecipient.prototype.validate = function (report) {
    if (!this.isOpen()) return true;
    var shouldReport = report !== false;
    if (shouldReport) this.clearAllErrors();

    var errors = {};
    var email = this.inputs.email ? this.inputs.email.value.trim() : '';
    var name = this.inputs.name ? this.inputs.name.value.trim() : '';
    var sendOn = this.inputs.send_on ? this.inputs.send_on.value : '';

    if (!email) {
      errors.email = t('emailRequired', 'Please enter a recipient email address.');
    } else if (!EMAIL_RE.test(email)) {
      errors.email = t('emailInvalid', 'Please enter a valid email address.');
    }
    if (!name) {
      errors.name = t('nameRequired', 'Please enter a recipient name.');
    }
    if (sendOn && this.inputs.send_on.dataset.today && sendOn < this.inputs.send_on.dataset.today) {
      errors.send_on = t('sendOnPast', 'Please choose a send date in the future.');
    }

    var keys = Object.keys(errors);
    if (!keys.length) return true;
    if (!shouldReport) return false;

    keys.forEach(
      function (key) {
        this.setError(key, errors[key]);
      }.bind(this)
    );
    this.open();
    var firstInvalid = this.inputs[keys[0]];
    if (firstInvalid) {
      window.setTimeout(function () {
        firstInvalid.focus();
      }, 100);
    }
    return false;
  };

  GiftCardRecipient.prototype.onFormClick = function (event) {
    var trigger = event.target.closest('[name="add"], .product-addcart, button[type="submit"]');
    if (!trigger || !this.form.contains(trigger)) return;
    if (this.validate()) return;
    event.preventDefault();
    event.stopPropagation();
  };

  GiftCardRecipient.prototype.onFormSubmit = function (event) {
    if (this.validate()) return;
    event.preventDefault();
    event.stopPropagation();
  };

  GiftCardRecipient.prototype.showServerErrors = function (response) {
    if (!this.isOpen() || !response) return false;
    var errors = response.errors;
    if (!errors || typeof errors !== 'object' || Array.isArray(errors)) return false;
    var shown = false;
    Object.keys(errors).forEach(
      function (key) {
        if (!this.inputs[key]) return;
        var value = errors[key];
        this.setError(key, Array.isArray(value) ? value.join(', ') : String(value));
        shown = true;
      }.bind(this)
    );
    if (shown) this.open();
    return shown;
  };

  GiftCardRecipient.prototype.reset = function () {
    if (!this.isOpen()) return;
    this.checkbox.checked = false;
    this.onToggle();
  };

  function init() {
    document.querySelectorAll('[data-gift-card-recipient]').forEach(function (root) {
      if (root.dataset.gcrReady === 'true') return;
      root.dataset.gcrReady = 'true';
      instances.push(new GiftCardRecipient(root));
    });
  }

  window.GiftCardRecipient = {
    init: init,
    showErrors: function (response) {
      return instances.reduce(function (shown, instance) {
        return instance.showServerErrors(response) || shown;
      }, false);
    },
    reset: function () {
      instances.forEach(function (instance) {
        instance.reset();
      });
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart:added', function () {
    window.GiftCardRecipient.reset();
  });
})();
